'use client'
import React, { useState } from 'react';

const MediaEnterainmentIndustries = ({ color, textcolor, active, activetext }) => {
  const [activeTab, setActiveTab] = useState('first');

  return (
    <section className={`${color} text-${textcolor} mt-20`}>
      <div className="container mt-5">
        <div className="text-center">
          <h2 className="sec-subtile-6">IT Solutions for Media and Entertainment Industry</h2>
        </div>
        <h3 className="text-center py-3">Advanced IT Solutions for the Media & Entertainment Industry</h3>
        <p className="text-center py-3">
          JBcodeapp’s tailored IT solutions empower media and entertainment companies with robust technology that drives content production, management, and distribution.
        </p>
        <div className="row mt-5">
          {/* Tab section */}
          <div className="col-md-3 col-sm-12 py-2">
            <div className="d-flex flex-column align-items-center  h-100">

              <div className="d-block d-sm-none overflow-x-auto whitespace-nowrap w-100">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'first' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('first')}
                >
                  OTT Streaming Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'second' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('second')}
                >
                  Digital Rights Management (DRM)

                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'third' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('third')}
                >
                  Media Asset Management Systems (MAM)

                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'four' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('four')}
                >
                  AI-Powered Content Recommendation Engines
                </button>

              </div>

              <div className="d-none d-sm-flex flex-column ">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'first' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('first')}
                >
                  OTT Streaming Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'second' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('second')}
                >
                  Digital Rights Management (DRM)

                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'third' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('third')}
                >
                  Media Asset Management Systems (MAM)

                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'four' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('four')}
                >
                  AI-Powered Content Recommendation Engines
                </button>

              </div>
            </div>
          </div>


          {/* Icon section */}
          <div className="col-md-9 col-sm-12 ">
            <div className="-brand__list -showcase-mixitup mt-3">
              {/* First Tab: EMR Solutions */}
              {activeTab === 'first' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">OTT Streaming Solutions</h3>
                        <p>
                          Develop feature-rich, scalable OTT platforms to deliver high-quality, on-demand content across multiple devices seamlessly.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Multi-device <br/>Streaming</h4>
                          <p>Stream content on various platforms like mobile, desktop, and smart TVs.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Adaptive Bitrate <br/>Streaming</h4>
                          <p>Automatically adjust the video quality based on the user's internet speed.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Content Delivery Network (CDN) Integration</h4>
                          <p>Ensure faster and more efficient content delivery globally.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Subscription & Payment Gateway</h4>
                          <p>Integrated payment systems for seamless subscription management.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Personalized Content Suggestions</h4>
                          <p>AI-driven algorithms to recommend content based on user preferences.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                        <h4 className="workflow__title-6">Real-time <br/>Analytics</h4>
                          <p>Monitor user engagement and streaming performance in real time.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                </>
              )}

              {/* Second Tab: Telemedicine Solutions */}
              {activeTab === 'second' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Digital Rights Management (DRM)</h3>
                        <p>
                          Protect digital assets with strong encryption and access control systems to prevent unauthorized usage or distribution.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Content Encryption</h4>
                          <p>Ensure secure media content delivery with advanced encryption protocols.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Access Control Systems</h4>
                          <p>Regulate who can view or download content based on user roles.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Geofencing Tools</h4>
                          <p>Restrict content availability to specific geographic regions.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Watermarking Solutions</h4>
                          <p>Embed digital watermarks to identify and track content.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">License Management</h4>
                          <p>Automate license handling to ensure legal content usage.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Tokenized Authentication</h4>
                          <p>Secure media access with time-sensitive, token-based authentication.</p>
                        </div>
                      </div>
                    </div>
                  </section>


                </>
              )}

              {/* Third Tab: HMS Solutions */}
              {activeTab === 'third' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Media Asset Management (MAM)</h3>
                        <p>
                          Efficiently manage, organize, and distribute media assets to streamline the entire production workflow.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Cloud-based Media Storage</h4>
                          <p>Store large media files securely on cloud servers with easy access.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">File Format Conversion</h4>
                          <p>Automatically convert media files to the required formats for various platforms.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Metadata Tagging</h4>
                          <p>Organize assets with detailed metadata tags for easier search and categorization.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Content Search & Retrieval</h4>
                          <p>Quickly locate specific files with powerful search capabilities.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Workflow Automation</h4>
                          <p>Automate repetitive tasks in the media production process for efficiency.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Role-based Access Control</h4>
                          <p>Assign permissions based on roles to ensure content security.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                </>
              )}

              {/* Fourth Tab: HIE Solutions */}
              {activeTab === 'four' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">AI-Powered Content Recommendation Engines</h3>
                        <p>
                          Use AI to enhance user experience with personalized recommendations based on their behavior and preferences.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">User Behavior Tracking</h4>
                          <p>Monitor and analyze user activities to personalize content suggestions.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Predictive Analytics</h4>
                          <p>Anticipate user preferences based on past viewing habits.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Content Filtering Algorithms</h4>
                          <p>Automatically filter content to match user preferences.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Machine Learning Models</h4>
                          <p>Continuously improve recommendations through machine learning.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Audience Segmentation</h4>
                          <p>Segment users based on behavior to deliver targeted recommendations.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Real-time Data Processing</h4>
                          <p>Process data in real time to provide up-to-the-minute recommendations.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                </>
              )}

              {/* Five Tab: HIE Solutions */}
              {/* {activeTab === 'five' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Custom ERP for Logistics</h3>
                        <p>
                          Our custom ERP solutions for logistics provide end-to-end control over resource planning, <br />
                          from supply chain management to customer order processing, ensuring smooth operations.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Resource Planning</h4>
                          <p>Plan and allocate resources efficiently to optimize operational workflows.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Order Processing</h4>
                          <p>Streamline the process of managing and processing across the supply chain.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Inventory Control</h4>
                          <p>Monitor and manage inventory levels to ensure supply meets demand.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Supplier Management</h4>
                          <p>Track and manage supplier interactions for timely order fulfillment.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Customer Order Updates</h4>
                          <p>Provide real-time updates to customers on order status and delivery progress.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Reporting and Analytics</h4>
                          <p>Generate detailed reports and analytics for better decision-making.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                </>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default MediaEnterainmentIndustries;
